/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MyPremiseSelectElementViewModel } from '../../models/my-premise-select-element-view-model';

export interface ElementsMyPremisesSelectGet$Params {

/**
 * A boolean query parameter for including future contracts for the premise.
 */
  includeFutureContracts?: boolean;

/**
 * Comma-separated list of contract types to filter by
 */
  contractTypeFilter?: string;

/**
 * If true, contract types in filter will be excluded from response (default is included)
 */
  excludeContractTypes?: boolean;

/**
 * If true, production and consumption premises for micro production will be combined into one premise with service group MicroProduction
 */
  combineMicroProductionPremises?: boolean;
}

export function elementsMyPremisesSelectGet(http: HttpClient, rootUrl: string, params?: ElementsMyPremisesSelectGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<MyPremiseSelectElementViewModel>>> {
  const rb = new RequestBuilder(rootUrl, elementsMyPremisesSelectGet.PATH, 'get');
  if (params) {
    rb.query('includeFutureContracts', params.includeFutureContracts, {});
    rb.query('contractTypeFilter', params.contractTypeFilter, {});
    rb.query('excludeContractTypes', params.excludeContractTypes, {});
    rb.query('combineMicroProductionPremises', params.combineMicroProductionPremises, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<MyPremiseSelectElementViewModel>>;
    })
  );
}

elementsMyPremisesSelectGet.PATH = '/elements/my-premises-select';
